import type { CookieSetOptions, Cookie } from 'universal-cookie';
import Cookies from 'universal-cookie';

import { ACCOUNT_IDENTITY } from '@/_config';

import { logger } from '../utils/logger';

const cookies = new Cookies();

export const getCookie = (key: string) => cookies.get(key);

export const setCookie = (key: string, value: Cookie, options: CookieSetOptions = { path: '/' }) => {
  cookies.set(key, value, options);
};

export const removeCookie = (key: string, options: CookieSetOptions = { path: '/' }) => cookies.remove(key, options);

export const setAuthTokens = (
  access: string,
  refresh: string,
  type = ACCOUNT_IDENTITY.STUDENT,
  options: CookieSetOptions = { path: '/' }
) => {
  setCookie('refresh', refresh, options);
  setCookie('access', access, options);
  setCookie('type', type ?? ACCOUNT_IDENTITY.STUDENT, options);
};

export const removeAuthTokens = (options: CookieSetOptions = { path: '/' }) => {
  logger.clearSession();
  removeCookie('access', options);
  removeCookie('refresh', options);
  removeCookie('type', options);
  logger.clearSession();
};

export const isLoggedIn = () => !!getCookie('access');

export const getAccountType = (type = getCookie('type')): ACCOUNT_IDENTITY =>
  type !== 'null' && !type ? type : ACCOUNT_IDENTITY.STUDENT;

export const isStudentAccount = (type = getCookie('type')): boolean =>
  type === ACCOUNT_IDENTITY.STUDENT || type === 'null';

export const isInstructorAccount = (type = getCookie('type')): boolean => type === ACCOUNT_IDENTITY.INSTRUCTOR;
